import { Avatar, Group, Text, Tooltip } from '@optiaxiom/react';

import { CustomIcon } from './CustomIcon';

type UserNameCellProps = {
  userId: string;
  userNameMap: Record<string, string>;
  isInstalled?: boolean;
};

export const UserNameCell = ({ userId, userNameMap, isInstalled = false }: UserNameCellProps) => {
  const name = userNameMap[userId];
  return (
    <Group gap="4" alignItems="center">
      {isInstalled ? (
        <Tooltip content="Installed from Optimizely's Agent Directory" delayDuration={0}>
          <Avatar bg="bg.default" size="sm">
            <CustomIcon name="optimizely" alt="Optimizely logo" height={12} />
          </Avatar>
        </Tooltip>
      ) : (
        name && <Avatar size="sm" name={name} colorScheme="purple" />
      )}
      <Text fontSize="sm" color="fg.tertiary">
        {isInstalled ? 'Optimizely' : name || '—'}
      </Text>
    </Group>
  );
};
